var _ = require('underscore');
var TableView = require('./../widget/brec-table/table-view/TableView');
var payableEstimatesListTemplate = require('./payableEstimatesListTemplate.hbs');
var PayableEstimatesItemView = require('./PayableEstimatesItemView.js');
var InsuranceEstimationDataBehavior = require('./../estimate/InsuranceEstimationDataBehavior');
var financialFeatureConfigModel = require('./../financial/financialFeatureConfigModel');

/**
 * Estimates List on Make Payment
 *
 * @class PayableEstimatesListView
 */
module.exports = TableView.extend({
  id: 'estimates-table',
  template: payableEstimatesListTemplate,
  itemContainer: 'payable-estimate-item',
  itemView: PayableEstimatesItemView,
  modelName: 'estimateModel',
  __itemContext: function() {
    var itemContext = TableView.prototype.__itemContext.apply(this);
    itemContext.paymentDetailsFormModel = this.model;
    return itemContext;
  },

  events: {
    'click [data-refetch-estimates-button]': '_fetchEstimates'
  },

  prepareFields: {
    payableEstimatesCount: '_getPayableEstimatesCount'
  },

  behaviors: {
    insuranceEstimations: {
      behavior: InsuranceEstimationDataBehavior,
      renderOnFetch: true,
      updateEvents: ['viewState:change:accountExternalIds', 'view.financialConfigLoaded:change'],
      ids: function(cache) {
        var isEstimatedCostEnabled = financialFeatureConfigModel.isEstimatedCostEnabled(financialFeatureConfigModel.CONFIG_LEVEL.NORMAL);
        if (!isEstimatedCostEnabled) {
          return;
        }
        var view = this.view;
        var thisFetchId = view._startLoading();
        var criteria = view._getInsuranceEstimationCriteria();
        return cache.fetchIdsByCriteria(criteria)
          .then(function(response) {
            return view.consumePartialListResponse(response, thisFetchId);
          })
          .always(function() {
            view._completeLoading(thisFetchId);
          });
      }
    }
  },


  /**
   * @method initialize
   * @param options {Object}
   *   @param options.patientVecnaId {String} the vecna id of the patient that owns the estimates in this payable bill list.
   *   @param options.appointmentExternalIds {String[]} the external ids of the appointments that owns the estimates in this payable bill list.
   *   @param options.model {PaymentDetailsFormModel} the form model to save any payment info to.
   *                                                  This is copied to model automagically by backbone constructor.
   *   @param options.tableState {TableState} the state & event bus used by the make payment widget.
   *
   * @override
   */
  initialize: function(options) {
    this._patientVecnaId = options.patientVecnaId;
    this._appointmentExternalIds = options.appointmentExternalIds;
    this._tableState = options.tableState;
    var insuranceEstimationsBehavior = this.getBehavior('insuranceEstimations');
    var insuranceEstimationCollection = insuranceEstimationsBehavior.data.privateCollection;
    this.collection = insuranceEstimationCollection;
    var paymentDetailsFormModel = this.model;
    paymentDetailsFormModel.setInsuranceEstimationCollection(insuranceEstimationCollection);
    this.on('submit', this._submit);
    this.on('change:accountExternalIds', this._payFull);
    this.on('change:accountExternalIds', this.render);
    this.listenTo(insuranceEstimationsBehavior, 'change:fetchSuccess', this._payFull);
    this.listenTo(this.viewState, 'change:accountExternalIds', this._payFull);
    this.listenTo(insuranceEstimationsBehavior, 'change:fetchSuccess', this.render);
    this.listenTo(this._tableState, 'updateEstimatePaid', this._fetchEstimates);
    financialFeatureConfigModel.loadOnce();
  },

  /**
   * Select full payment for the estimated amount.
   * @method _payFull
   * @private
   */
  _payFull: function() {
    var paymentDetailsFormModel = this.model;
    var accountExternalIds = this.get('accountExternalIds');
    _.each(this.collection.models, function(estimateModel) {
      if (!estimateModel.get('hasUnapprovedInsuranceUpdates') && _.contains(accountExternalIds, estimateModel.get('accountNumber'))) {
        paymentDetailsFormModel.payFullEstimate(estimateModel);
      }
    });
  },

  /**
   * A method to fetch estimates.
   * @method _fetchEstimates
   * @private
   */
  _fetchEstimates: function() {
    this.getBehavior('insuranceEstimations').fetch();
  },

  /**
   * Set the accountExternalIds when it is loaded from a parent view
   * @method setAccountExternalIds
   * @param accountExternalIds the ids of the account containing estimates to pay if a specific one exists
   */
  setAccountExternalIds: function(accountExternalIds) {
    this.set('accountExternalIds', accountExternalIds);
    this.collection.setAccountNumbersToSortBy(accountExternalIds);
  },

  /**
   * Trigger in-page validation for the current form.
   * @method _submit
   * @private
   */
  _submit: function() {
    _.each(this.getItemViews(), function(itemView) {
      itemView.trigger('submit');
    });
  },

  /**
   * @method _getInsuranceEstimationCriteria
   * @returns {Object} the insurance estimation criteria to pass to the InsuranceEstimationExtService
   * @private
   */
  _getInsuranceEstimationCriteria: function() {
    return {
      patientVecnaId: this._patientVecnaId
    };
  },

  /**
   * This is used by list view to determine which models to render.  In this case we do some client-side filtering
   * to remove the insurance estimations that has unapproved insurance updates on the same account.
   * @method modelsToRender
   * @return {InsuranceEstimation[]} the models to actually render by this list view.
   * @override
   */
  modelsToRender: function() {
    var allModels = this.collection ? this.collection.models : [];
    return _.filter(allModels, function(model) {
      var hasUnapprovedInsuranceUpdates = model.get('hasUnapprovedInsuranceUpdates');
      return !hasUnapprovedInsuranceUpdates;
    });
  },

  /**
   * @method _getPayableEstimatesCount
   * @returns {Number} the number of payable estimates fetched from the server.  returns 0 if none have been fetched.
   * @private
   */
  _getPayableEstimatesCount: function() {
    var payableEstimatesCount = this.modelsToRender() && this.modelsToRender().length;
    return payableEstimatesCount || 0;
  },

  /**
   * @method hasPayableEstimates
   * @returns {boolean} if the number of payable estimates is greater than 0
   */
  hasPayableEstimates: function() {
    return this._getPayableEstimatesCount() > 0;
  }
});
